import { Row, Col } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { FormatData } from "utils/FormatData";
import { dayjs } from "Config/dayjs";

interface DetailsInfoProps extends WithTranslation {
  fileOwner: string;
  size: number;
  lastChange: number;
  guid: string;
  md5: string;
  sha: string;
}

export const DetailsInfo = withTranslation(I18N_NS.PROJECT)(
  ({ t, fileOwner, size, lastChange, guid, md5, sha }: DetailsInfoProps) => {
    return (
      <div className="file-details--info">
        <Row>
          <Col span={8} className="file-details--title">
            {t("Owner")}:
          </Col>
          <Col span={16}>{fileOwner}</Col>
        </Row>
        <Row>
          <Col span={8} className="file-details--title">
            {t("Size")}:
          </Col>
          <Col span={16}>{FormatData.formatBytes(size, 2)}</Col>
        </Row>
        <Row>
          <Col span={8} className="file-details--title">
            {t("Last change")}:
          </Col>
          <Col span={16}>{dayjs(+lastChange).format("lll")}</Col>
        </Row>
        <Row>
          <Col span={8} className="file-details--title">
            {t("File GUID")}:
          </Col>
          <Col span={16}>{guid}</Col>
        </Row>
        <Row>
          <Col span={8} className="file-details--title">
            {t("Checksum")} {"(MD5)"}:{" "}
          </Col>
          <Col span={16}>{md5}</Col>
        </Row>
        <Row>
          <Col span={8} className="file-details--title">
            {t("Checksum")} {"(SHA256)"}:{" "}
          </Col>
          <Col span={16}>{sha}</Col>
        </Row>
        {/* <Row>
        <Col span={8} className="file-details--title">
          Checksum (SHA-265):
            </Col>
        <Col span={16}>
          3940F99CD821D4ED1D9F96E2B7DDA739DE7D78571463B4C3883BD3FCD892C541
            </Col>
      </Row> */}
      </div>
    );
  }
);
